import { isUserCustomer } from '../util/user/userUtils';
export class ClaimGroup {
  constructor() {
    let claimGroup = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    this.claimGroup = claimGroup;
  }
  getOverviewLink(user) {
    const isCustomer = isUserCustomer(user);
    return isCustomer ? "/".concat(user.account_type, "/companies/").concat(this.claimGroup.company_id, "/master") : "/".concat(user.account_type, "/claim_groups/").concat(this.claimGroup.id, "/project_overview");
  }
  static load(claimGroupJsonObject) {
    return new ClaimGroup(claimGroupJsonObject);
  }
}